module.exports = __webpack_public_path__ + "media/badges/mystery-hexagon-750bff1a.png";